/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tts_Tool_Upgrade_TitleInputs */

const en_tts_tool_upgrade_title = /** @type {(inputs: Tts_Tool_Upgrade_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Need longer documents?`)
};

const es_tts_tool_upgrade_title = /** @type {(inputs: Tts_Tool_Upgrade_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Necesitas documentos más largos?`)
};

/**
* | output |
* | --- |
* | "Need longer documents?" |
*
* @param {Tts_Tool_Upgrade_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const tts_tool_upgrade_title = /** @type {((inputs?: Tts_Tool_Upgrade_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tts_Tool_Upgrade_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tts_tool_upgrade_title(inputs)
	return en_tts_tool_upgrade_title(inputs)
});